import _ from "lodash";
import { getMemoizedFunction } from "Utils";

const getActiveTabConfig = ({ allOptions, activeTab }) => {
  return _.get(
    _.find(allOptions, option => option.key === activeTab),
    "config",
    {}
  );
};

const getSelectedEvidenceCount = ({ selectedCards }) => {
  return _.sum(_.map(selectedCards, cardType => _.size(cardType)));
};

const getAddButtonDisabilityStatus = ({
  initiallySelectedEvidence,
  selectedCards,
}) => {
  const initialFeedTypes = _.keys(initiallySelectedEvidence);

  const isInitialEvidencePresent = _.some(initialFeedTypes, feedType => {
    const feedEvidence = initiallySelectedEvidence[feedType];
    return !_.isEmpty(feedEvidence);
  });

  const selectedEvidenceFeedTypes = _.keys(selectedCards);

  const isEvidencePresent = _.some(selectedEvidenceFeedTypes, feedType => {
    const feedEvidence = selectedCards[feedType];
    return !_.isEmpty(feedEvidence);
  });

  return !(isEvidencePresent || isInitialEvidencePresent);
};

export const getAddButtonDisabilityStatusMemoized = getMemoizedFunction(
  getAddButtonDisabilityStatus
);

export const getActiveTabConfigMemoized = getMemoizedFunction(
  getActiveTabConfig
);

export const getSelectedEvidenceCountMemoized = getMemoizedFunction(
  getSelectedEvidenceCount
);
